<template>
<div>
    <v-card
      outlined
    >
    <v-card-text
      class="d-flex flex-column"
    >
      <blur-hash-canvas :hash="this.image.hash" height="200" v-if="!isLoaded"/>
      <v-img
          class="white--text align-end"
          contain
          :src="getImageFullUrl()"
          @load="imageLoaded"
      />
     </v-card-text>

         <!-- <v-img
            class="white--text align-end"
            height="200px"
            contain
            :src="this.url"
        /> -->
     <v-card-actions>
        <v-btn
          text
          color="accent"
          @click.stop="showDeleteDialog=true"
          v-bind:loading="loading"
        ><v-icon>{{ icons.delete }}</v-icon>
        </v-btn>
    </v-card-actions>
    </v-card>
    <DeleteDialog :data="{id:this.id}" :visible="showDeleteDialog" @close="showDeleteDialog=false" @confirmAction="deletingImage"/>

</div>
</template>
<script>
import DeleteDialog from '@/components/ConfirmDeleteDialog.vue'
import snackbar from '@/utils/snackbar'
import imageApi from '@/api/imageApi'
import { mdiDelete } from '@mdi/js'
import urlUtils from '@/utils/urlUtils'

export default {
  data () {
    return {
      isLoaded: false,
      icons: {
        delete: mdiDelete
      },
      showDeleteDialog: false,
      loading: false
    }
  },
  components: {
    DeleteDialog
  },

  props: {
    image: {
      type: Object,
      default: null,
      required: true
    },
    id: {
      type: Number,
      default: -1
    }
  },
  methods: {
    getImageFullUrl () {
      var k = urlUtils.getImageUrl(this.image.path)
      return k
    },
    imageLoaded () {
      this.$log.info('Image loaded')
      this.isLoaded = true
    },
    async deletingImage (data) {
      if (data !== null && data.id !== undefined) {
        const id = data.id
        this.loading = true
        try {
          const result = await imageApi.delete(id)
          if (result.data === 'success') {
            snackbar.show('Image deleted successfully', 'success')
            this.$emit('delete_success')
          }
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
